/* import __COLOCATED_TEMPLATE__ from './zendesk-data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { type PulseAccordion } from 'glint/pulse';
import { action } from '@ember/object';

interface Signature {
  Args: {
    accordion: PulseAccordion;
    onContinue: () => void;
  };
}

export default class ZendeskDataComponent extends Component<Signature> {
  @action
  continue() {
    if (this.args.onContinue) {
      this.args.onContinue();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::ZendeskData': typeof ZendeskDataComponent;
  }
}
